import Logout from "assets/icons/Logout.svg"
import { auth } from "auth"
import { Button, Modal } from "materia"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { sendVuplexMessage } from "../../../../vuplex/sendVuplexMessage"
import { BigItem } from "../components"
import s from "./styles.module.scss"

type ButtonLogoutProps = { isSingleLogOutEnabled: boolean }
export const ButtonLogout = ({ isSingleLogOutEnabled }: ButtonLogoutProps) => {
  const { t } = useTranslation()

  const [isLogoutConfirmationModalOpen, setLogoutConfirmationModalOpen] =
    useState(false)

  const onLogout = () => {
    sendVuplexMessage({ type: "LOGOUT" })
    if (isSingleLogOutEnabled) auth.logoutAndSLORedirect()
    else auth.logoutAndLogin()
  }

  return (
    <>
      <BigItem
        title={t("settings.LOGOUT")}
        onClick={() => setLogoutConfirmationModalOpen(true)}
        icon={Logout}
        data-testid="header-menu-logout-button"
      />
      {isLogoutConfirmationModalOpen && (
        <LogoutConfirmationModal
          onCancel={() => setLogoutConfirmationModalOpen(false)}
          onConfirm={onLogout}
        />
      )}
    </>
  )
}

export const LogoutConfirmationModal = ({
  onConfirm,
  onCancel,
}: {
  onConfirm: () => void
  onCancel: () => void
}) => {
  const { t } = useTranslation()

  return (
    <Modal onClose={onCancel} ariaLabel="confirm logout">
      <div className={s.confirmLogout__content}>
        <h2>{t("settings.CONFIRM_LOGOUT")}</h2>
        <div className={s.confirmLogout__actions}>
          <Button theme="blue" onClick={onConfirm}>
            {t("settings.LOGOUT")}
          </Button>
          <Button theme="cancel" onClick={onCancel}>
            {t("actions.CANCEL")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
